export const ROUTE_MAIN = '/'
export const ROUTE_SUPPORT = '/support'
